import { baseAxios } from "../index";

const config = () => ({
  headers: { token: localStorage.getItem("token") },
});

export async function getAdminMemberTerms() {
  try {
    const response = await baseAxios.get("webMemberTerms", config());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function updateAdminMemberTerms(data) {
  try {
    const response = await baseAxios.put("webMemberTerms", data, config());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}
